import React from 'react'
import { useExportFiestaPoint, useGetFiestaPoints, useExportFiestaTicket } from '../../api/point'
import { PointPanelScreen } from '../shared/PointPanelScreen'
import { OrderSummary } from './OrderSummary'
import { Box, Button, CircularProgress } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import { useAuth } from '../../api/context/UserAuthContext'
import { useSnackbar } from 'notistack'

export const FiestaPoints = () => {
  const { user } = useAuth()
  const exportApi = useExportFiestaTicket()
  const { enqueueSnackbar } = useSnackbar()

  const handleExport = async () => {
    const res = await exportApi
      .mutateAsync({})
      .catch((e) => enqueueSnackbar('Failed to export data', { variant: 'error' }))
    const url = URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'Fiesta Ticket')
    document.body.appendChild(link)
    link.click()
    if (res?.status === 200) enqueueSnackbar(`Exported`, { variant: 'success' })
    return res
  }

  const columns = [
    { id: 'companyName', label: 'Company Name' },
    {
      id: 'salesIds',
      label: 'Sales Id',
      view: ({ salesIds = [] }) => (
        <>
          {salesIds.map((item) => (
            <div key={item}>{item}</div>
          ))}
        </>
      ),
    },
    {
      id: 'orders',
      label: 'Point Details',
      view: OrderSummary,
    },
    { id: 'point', label: 'Total Tickets' },
  ]

  const ExportTicket = () =>
    user?.isPointSystemAdmin && (
      <Box display='flex' justifyContent='flex-end'>
        <Button
          startIcon={<DownloadIcon />}
          endIcon={exportApi.isLoading && <CircularProgress size='1.5rem' />}
          onClick={handleExport}
          disabled={exportApi.isLoading}
        >
          Ticket Export
        </Button>
      </Box>
    )

  return (
    <PointPanelScreen
      title='Fiesta Point'
      useExportApi={useExportFiestaPoint}
      useGetPoints={useGetFiestaPoints}
      columns={columns}
      customComponent={ExportTicket}
    />
  )
}
